import { jsx as r, jsxs as h } from "react/jsx-runtime";
import { useMemo as k, useState as H, useRef as je, useEffect as Ge, createContext as ze, useContext as Ee } from "react";
import { a as Re, A as Ie } from "./Avatar-BzalLvjS.js";
import { I as U, B as A, S as Me } from "./Input-s7q1Bymv.js";
import { B as Ke } from "./Badge-CljJSGSb.js";
import { T as x } from "./Typography-DjQwU5Xn.js";
import { S as Oe } from "./Skeleton-D_CC12vW.js";
import { C as We } from "./Card-1TvXi1hD.js";
import { A as qe } from "./Alert-CFjABKUQ.js";
import { T as Ve } from "./Tabs-B3UxJBCl.js";
import { B as $e } from "./Breadcrumbs-BfYr-pLH.js";
import { a as Ye } from "./FormField-sOzp-7h5.js";
import { S as Je } from "./Stack-B2DIYo_X.js";
import { C as Xe, G as Ze, I as _e } from "./Container-Da-5LaBC.js";
import { N as Qe, b as et, E as tt, P as at, D as nt, a as rt } from "./DataGrid-C7ruANGS.js";
import { R as it, S as ot, k as st, v as ct, b as lt, U as dt, T as pt, m as mt, l as gt, A as ht, i as ut, K as yt, f as bt, e as ft, d as xt, C as St, c as wt, P as vt, a as Ct, j as kt, D as Ht } from "./KanbanBoard-qgBeD7kn.js";
import { S as Ut, L as At, E as Pt } from "./Section-DbfMk74d.js";
import { S as Nt, T as Tt } from "./SchemaField-H3vu6nLQ.js";
import { a as Bt, S as Ft } from "./SchemaForm-Bt3uM7o1.js";
import { c as b } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
import { marked as Lt } from "marked";
import { S as Dt } from "./search-B4CsPni9.js";
import { G as jt } from "./grid-3x3-D_KKntnt.js";
import { X as Gt } from "./x-5QknLR1d.js";
import { z as e } from "zod";
const P = ({
  content: t,
  ...n
}) => {
  const i = k(() => {
    try {
      return Lt.parse(t);
    } catch (s) {
      return console.error("Error parsing markdown:", s), "";
    }
  }, [t]);
  return /* @__PURE__ */ r(it, { html: i, ...n });
}, zt = ({
  value: t,
  onChange: n,
  className: i,
  placeholder: s = "Write something...",
  minHeight: c = "200px",
  label: d,
  error: g,
  disabled: p = !1
}) => {
  const [l, m] = H("write"), o = je(null);
  Ge(() => {
    const u = o.current;
    u && l === "write" && (u.style.height = "auto", u.style.height = `${Math.max(u.scrollHeight, 150)}px`);
  }, [t, l]);
  const y = (u) => {
    if (u.key === "Tab") {
      u.preventDefault();
      const f = u.currentTarget, C = f.selectionStart, Le = f.selectionEnd, De = t.substring(0, C) + "  " + t.substring(Le);
      n(De), requestAnimationFrame(() => {
        f.selectionStart = f.selectionEnd = C + 2;
      });
    }
  };
  return b(
    "flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
    g && "border-destructive focus-visible:ring-destructive"
  ), /* @__PURE__ */ h("div", { className: b("flex flex-col gap-2", i), children: [
    d && /* @__PURE__ */ r("label", { className: "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70", children: d }),
    /* @__PURE__ */ h("div", { className: b(
      "flex flex-col rounded-md border border-input overflow-hidden bg-background focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2",
      g && "border-destructive focus-within:ring-destructive",
      p && "opacity-50 pointer-events-none"
    ), children: [
      /* @__PURE__ */ r("div", { className: "flex items-center border-b border-border bg-muted/50 px-2 py-1", children: /* @__PURE__ */ h("div", { className: "flex gap-1", children: [
        /* @__PURE__ */ r(
          "button",
          {
            type: "button",
            onClick: () => m("write"),
            className: b(
              "px-3 py-1 text-xs font-medium rounded-sm transition-colors",
              l === "write" ? "bg-background text-foreground shadow-sm" : "text-muted-foreground hover:bg-background/50 hover:text-foreground"
            ),
            children: "Write"
          }
        ),
        /* @__PURE__ */ r(
          "button",
          {
            type: "button",
            onClick: () => m("preview"),
            className: b(
              "px-3 py-1 text-xs font-medium rounded-sm transition-colors",
              l === "preview" ? "bg-background text-foreground shadow-sm" : "text-muted-foreground hover:bg-background/50 hover:text-foreground"
            ),
            children: "Preview"
          }
        )
      ] }) }),
      /* @__PURE__ */ r(
        "div",
        {
          className: "relative w-full",
          style: { minHeight: typeof c == "number" ? `${c}px` : c },
          children: l === "write" ? /* @__PURE__ */ r(
            "textarea",
            {
              ref: o,
              value: t,
              onChange: (u) => n(u.target.value),
              onKeyDown: y,
              placeholder: s,
              className: "w-full h-full min-h-[inherit] resize-y bg-transparent p-4 outline-none text-sm font-mono leading-relaxed",
              disabled: p
            }
          ) : /* @__PURE__ */ r("div", { className: "w-full h-full min-h-[inherit] p-4 overflow-auto border-none bg-surface/30", children: t ? /* @__PURE__ */ r(P, { content: t }) : /* @__PURE__ */ r("p", { className: "text-muted-foreground text-sm italic", children: "Nothing to preview" }) })
        }
      )
    ] }),
    g && /* @__PURE__ */ r("p", { className: "text-sm font-medium text-destructive", children: g })
  ] });
}, N = e.enum(["sm", "md", "lg"]), T = e.enum(["primary", "secondary", "outline", "ghost", "danger"]), a = e.object({
  className: e.string().optional(),
  testId: e.string().optional()
}), B = a.extend({
  type: e.literal("Button"),
  variant: T.optional().default("primary"),
  size: N.optional().default("md"),
  isLoading: e.boolean().optional(),
  disabled: e.boolean().optional(),
  children: e.string().describe("Button label text"),
  onClick: e.string().optional().describe("Action identifier for click handler")
}), F = a.extend({
  type: e.literal("Badge"),
  variant: e.enum(["gray", "red", "yellow", "green", "blue", "purple"]).optional(),
  children: e.string().describe("Badge text")
}), L = a.extend({
  type: e.literal("Input"),
  placeholder: e.string().optional(),
  disabled: e.boolean().optional(),
  name: e.string().describe("Field name for form binding"),
  label: e.string().optional()
}), D = a.extend({
  type: e.literal("Typography"),
  variant: e.enum(["h1", "h2", "h3", "h4", "body", "small", "caption"]).optional(),
  children: e.string().describe("Text content")
}), j = a.extend({
  type: e.literal("Spinner"),
  size: N.optional()
}), G = a.extend({
  type: e.literal("Skeleton"),
  variant: e.enum(["text", "circular", "rectangular"]).optional(),
  width: e.union([e.string(), e.number()]).optional(),
  height: e.union([e.string(), e.number()]).optional()
}), z = a.extend({
  type: e.literal("Card"),
  children: e.any().optional().describe("Card content")
}), Et = a.extend({
  type: e.literal("Progress"),
  value: e.number().min(0).max(100),
  showLabel: e.boolean().optional()
}), E = a.extend({
  type: e.literal("Avatar"),
  src: e.string().optional().describe("Image URL"),
  alt: e.string().optional(),
  fallback: e.string().optional().describe("Name for initials fallback"),
  size: e.enum(["xs", "sm", "md", "lg", "xl", "2xl"]).optional(),
  shape: e.enum(["circle", "square"]).optional(),
  status: e.enum(["online", "offline", "away", "busy"]).optional()
}), R = a.extend({
  type: e.literal("AvatarGroup"),
  avatars: e.array(e.object({
    src: e.string().optional(),
    fallback: e.string().optional()
  })),
  max: e.number().optional(),
  size: e.enum(["xs", "sm", "md", "lg", "xl", "2xl"]).optional()
}), I = a.extend({
  type: e.literal("Alert"),
  variant: e.enum(["info", "success", "warning", "error"]).optional(),
  title: e.string().optional(),
  children: e.string().describe("Alert message"),
  dismissible: e.boolean().optional()
}), M = a.extend({
  type: e.literal("Tabs"),
  tabs: e.array(e.object({
    id: e.string(),
    label: e.string(),
    content: e.any().optional()
  })),
  defaultValue: e.string().optional()
}), K = a.extend({
  type: e.literal("Breadcrumbs"),
  items: e.array(e.object({
    label: e.string(),
    href: e.string().optional()
  }))
}), O = a.extend({
  type: e.literal("FormField"),
  name: e.string(),
  label: e.string(),
  description: e.string().optional(),
  error: e.string().optional(),
  required: e.boolean().optional(),
  children: e.any().optional()
}), W = a.extend({
  type: e.literal("Stack"),
  gap: e.union([e.number(), e.string()]).optional(),
  align: e.enum(["start", "center", "end", "stretch"]).optional(),
  children: e.array(e.any()).describe("Child components")
}), q = a.extend({
  type: e.literal("Inline"),
  gap: e.union([e.number(), e.string()]).optional(),
  align: e.enum(["start", "center", "end", "stretch"]).optional(),
  children: e.array(e.any()).describe("Child components")
}), V = a.extend({
  type: e.literal("Grid"),
  columns: e.union([e.number(), e.string()]).optional(),
  gap: e.union([e.number(), e.string()]).optional(),
  children: e.array(e.any()).describe("Grid items")
}), $ = a.extend({
  type: e.literal("Container"),
  maxWidth: e.enum(["sm", "md", "lg", "xl", "2xl", "full"]).optional(),
  children: e.any().describe("Container content")
}), Y = e.object({
  key: e.string(),
  header: e.string(),
  width: e.number().optional(),
  sortable: e.boolean().optional(),
  align: e.enum(["left", "center", "right"]).optional()
}), J = a.extend({
  type: e.literal("DataGrid"),
  columns: e.array(Y),
  data: e.string().describe('Data binding expression, e.g., "{{items}}"'),
  keyExtractor: e.string().optional().describe("Key field name"),
  emptyMessage: e.string().optional(),
  isLoading: e.boolean().optional()
}), X = a.extend({
  type: e.literal("DataTable"),
  columns: e.array(Y),
  data: e.string().describe("Data binding expression"),
  keyExtractor: e.string().optional()
}), Z = a.extend({
  type: e.literal("Pagination"),
  currentPage: e.number(),
  totalPages: e.number(),
  onPageChange: e.string().optional().describe("Action identifier")
}), _ = a.extend({
  type: e.literal("Dialog"),
  title: e.string(),
  description: e.string().optional(),
  open: e.boolean().optional(),
  children: e.any().optional()
}), Q = a.extend({
  type: e.literal("Drawer"),
  title: e.string().optional(),
  side: e.enum(["left", "right", "top", "bottom"]).optional(),
  open: e.boolean().optional(),
  children: e.any().optional()
}), ee = a.extend({
  type: e.literal("Dropdown"),
  trigger: e.any().describe("Trigger element"),
  items: e.array(e.object({
    id: e.string(),
    label: e.string(),
    onClick: e.string().optional(),
    variant: e.enum(["default", "danger"]).optional()
  }))
}), Rt = a.extend({
  type: e.literal("Toast"),
  title: e.string(),
  description: e.string().optional(),
  variant: e.enum(["default", "success", "error", "warning"]).optional()
}), te = a.extend({
  type: e.literal("EmptyState"),
  title: e.string(),
  description: e.string().optional(),
  icon: e.string().optional().describe("Icon name from lucide-react"),
  action: e.object({
    label: e.string(),
    onClick: e.string()
  }).optional()
}), ae = a.extend({
  type: e.literal("ErrorState"),
  title: e.string().optional(),
  description: e.string().optional(),
  onRetry: e.string().optional().describe("Action identifier for retry")
}), ne = a.extend({
  type: e.literal("LoadingState"),
  message: e.string().optional()
}), re = a.extend({
  type: e.literal("PageHeader"),
  title: e.string(),
  description: e.string().optional(),
  actions: e.array(e.object({
    label: e.string(),
    onClick: e.string(),
    variant: T.optional()
  })).optional(),
  breadcrumbs: e.array(e.object({
    label: e.string(),
    href: e.string().optional()
  })).optional()
}), ie = e.lazy(() => e.object({
  id: e.string(),
  label: e.string(),
  icon: e.string().optional(),
  href: e.string().optional(),
  onClick: e.string().optional(),
  isActive: e.boolean().optional(),
  items: e.array(ie).optional()
})), oe = a.extend({
  type: e.literal("Sidebar"),
  items: e.array(ie),
  header: e.any().optional(),
  footer: e.any().optional(),
  collapsible: e.boolean().optional()
}), se = a.extend({
  type: e.literal("Toolbar"),
  children: e.array(e.any()).describe("Toolbar items")
}), ce = a.extend({
  type: e.literal("Section"),
  title: e.string().optional(),
  description: e.string().optional(),
  children: e.any()
}), Ca = e.object({
  name: e.string()
}).catchall(e.number()), le = a.extend({
  type: e.literal("ChartLine"),
  data: e.string().describe("Data binding expression"),
  categories: e.array(e.string()),
  index: e.string(),
  h: e.number().optional()
}), de = a.extend({
  type: e.literal("ChartBar"),
  data: e.string().describe("Data binding expression"),
  categories: e.array(e.string()),
  index: e.string(),
  h: e.number().optional()
}), pe = a.extend({
  type: e.literal("ChartArea"),
  data: e.string().describe("Data binding expression"),
  categories: e.array(e.string()),
  index: e.string(),
  h: e.number().optional()
}), me = a.extend({
  type: e.literal("ChartPie"),
  data: e.string().describe("Data binding expression"),
  category: e.string(),
  value: e.string(),
  h: e.number().optional()
}), ge = a.extend({
  type: e.literal("KpiCard"),
  title: e.string(),
  metric: e.string(),
  subtext: e.string().optional(),
  icon: e.string().optional(),
  children: e.any().optional().describe("Optional sparkline")
}), he = a.extend({
  type: e.literal("Sparkline"),
  data: e.string().describe("Data binding expression"),
  categories: e.array(e.string()),
  index: e.string(),
  h: e.number().optional()
}), ue = a.extend({
  type: e.literal("AuthenticatedAppShell"),
  children: e.array(e.any()).describe("Sidebar, Header, and Main components")
}), ka = a.extend({
  type: e.literal("AuthenticatedAppShell.Sidebar"),
  children: e.any()
}), Ha = a.extend({
  type: e.literal("AuthenticatedAppShell.Header"),
  children: e.any()
}), Ua = a.extend({
  type: e.literal("AuthenticatedAppShell.Main"),
  children: e.any()
}), ye = a.extend({
  type: e.literal("SettingsLayout"),
  nav: e.array(e.object({
    id: e.string(),
    label: e.string(),
    href: e.string().optional()
  })),
  children: e.any()
}), be = a.extend({
  type: e.literal("SidebarLayout"),
  sidebar: e.any(),
  children: e.any()
}), fe = a.extend({
  type: e.literal("TextField"),
  name: e.string(),
  label: e.string().optional(),
  placeholder: e.string().optional(),
  description: e.string().optional(),
  required: e.boolean().optional()
}), xe = a.extend({
  type: e.literal("SelectField"),
  name: e.string(),
  label: e.string().optional(),
  options: e.array(e.object({
    label: e.string(),
    value: e.string()
  })),
  placeholder: e.string().optional()
}), Se = a.extend({
  type: e.literal("SmartForm"),
  onSubmit: e.string().describe("Action identifier for form submission"),
  children: e.array(e.any()).describe("Form fields")
}), we = a.extend({
  type: e.literal("SchemaForm"),
  jsonSchema: e.object({
    type: e.literal("object"),
    properties: e.record(e.any()),
    required: e.array(e.string()).optional()
  }),
  onSubmit: e.string().describe("Action identifier for form submission")
}), ve = a.extend({
  type: e.literal("TenantSwitcher"),
  tenants: e.array(e.object({
    id: e.string(),
    name: e.string(),
    logo: e.string().optional()
  })),
  currentTenant: e.string(),
  onSwitch: e.string().describe("Action identifier")
}), Ce = a.extend({
  type: e.literal("UserMenu"),
  user: e.object({
    name: e.string(),
    email: e.string().optional(),
    avatar: e.string().optional()
  }),
  actions: e.array(e.object({
    id: e.string(),
    label: e.string(),
    onClick: e.string()
  }))
}), ke = a.extend({
  type: e.literal("PermissionGuard"),
  requiredPermission: e.string(),
  fallback: e.any().optional(),
  children: e.any()
}), He = a.extend({
  type: e.literal("NetworkBoundary"),
  isLoading: e.boolean().optional(),
  error: e.any().optional(),
  onRetry: e.string().optional(),
  children: e.any()
}), Ue = a.extend({
  type: e.literal("RichTextEditor"),
  value: e.string().optional(),
  onChange: e.string().optional().describe("Action identifier"),
  placeholder: e.string().optional(),
  readOnly: e.boolean().optional()
}), Ae = a.extend({
  type: e.literal("MarkdownRenderer"),
  content: e.string()
}), It = a.extend({
  type: e.literal("KanbanCard"),
  id: e.string(),
  title: e.string(),
  description: e.string().optional()
}), Mt = a.extend({
  type: e.literal("KanbanColumn"),
  id: e.string(),
  title: e.string(),
  cards: e.array(It)
}), Pe = a.extend({
  type: e.literal("KanbanBoard"),
  columns: e.array(Mt),
  onCardMove: e.string().optional().describe("Action identifier")
}), Ne = a.extend({
  type: e.literal("WorkflowBuilder"),
  steps: e.array(e.object({
    id: e.string(),
    label: e.string()
  })),
  currentStep: e.number().optional(),
  children: e.any()
}), Kt = e.object({
  id: e.string(),
  label: e.string(),
  description: e.string().optional(),
  group: e.string().optional(),
  shortcut: e.array(e.string()).optional(),
  onSelect: e.string().optional().describe("Action identifier")
}), Te = a.extend({
  type: e.literal("CommandPalette"),
  items: e.array(Kt),
  placeholder: e.string().optional(),
  emptyMessage: e.string().optional(),
  onSelect: e.string().optional().describe("Action identifier")
}), Ot = e.discriminatedUnion("type", [
  // Atoms
  B,
  F,
  L,
  D,
  j,
  G,
  z,
  Et,
  E,
  R,
  // Molecules
  I,
  M,
  K,
  O,
  // Layouts
  W,
  q,
  V,
  $,
  // Patterns
  J,
  X,
  Z,
  _,
  Q,
  ee,
  Rt,
  te,
  ae,
  ne,
  re,
  oe,
  se,
  ce,
  // Charts
  le,
  de,
  pe,
  me,
  ge,
  he,
  // Layouts
  ue,
  ye,
  be,
  // Forms
  fe,
  xe,
  Se,
  we,
  // SaaS
  ve,
  Ce,
  ke,
  He,
  // Rich Text
  Ue,
  Ae,
  // Kanban
  Pe,
  // Workflow
  Ne,
  // Command Palette
  Te
]), Wt = ({
  nodes: t,
  onNodeDragStart: n,
  onNodeClick: i,
  className: s
}) => {
  const [c, d] = H(""), p = t.filter(
    (l) => {
      var m;
      return l.label.toLowerCase().includes(c.toLowerCase()) || ((m = l.description) == null ? void 0 : m.toLowerCase().includes(c.toLowerCase()));
    }
  ).reduce((l, m) => {
    const o = m.category || "General";
    return l[o] || (l[o] = []), l[o].push(m), l;
  }, {});
  return /* @__PURE__ */ h("div", { className: b("flex flex-col h-full bg-background border-r border-border w-64", s), children: [
    /* @__PURE__ */ h("div", { className: "p-4 border-b border-border space-y-4", children: [
      /* @__PURE__ */ r(x, { variant: "h4", className: "text-sm font-semibold", children: "Components" }),
      /* @__PURE__ */ h("div", { className: "relative", children: [
        /* @__PURE__ */ r(Dt, { className: "absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" }),
        /* @__PURE__ */ r(
          U,
          {
            placeholder: "Search nodes...",
            className: "pl-9",
            value: c,
            onChange: (l) => d(l.target.value)
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ r("div", { className: "flex-1 overflow-y-auto p-4 space-y-6", children: Object.entries(p).map(([l, m]) => /* @__PURE__ */ h("div", { className: "space-y-3", children: [
      /* @__PURE__ */ r(x, { variant: "body", className: "text-xs font-semibold text-muted-foreground uppercase tracking-wider", children: l }),
      /* @__PURE__ */ r("div", { className: "grid gap-2", children: m.map((o) => /* @__PURE__ */ h(
        "div",
        {
          className: "group flex items-center gap-3 p-2 rounded-md border border-border bg-card hover:border-primary/50 hover:bg-accent/50 cursor-grab active:cursor-grabbing transition-colors",
          draggable: !0,
          onDragStart: (y) => n == null ? void 0 : n(o, y),
          onClick: () => i == null ? void 0 : i(o),
          children: [
            /* @__PURE__ */ r("div", { className: "flex h-8 w-8 items-center justify-center rounded-md bg-muted text-muted-foreground group-hover:text-primary transition-colors", children: o.icon || /* @__PURE__ */ r(jt, { className: "h-4 w-4" }) }),
            /* @__PURE__ */ h("div", { className: "flex flex-col", children: [
              /* @__PURE__ */ r("span", { className: "text-sm font-medium leading-none", children: o.label }),
              o.description && /* @__PURE__ */ r("span", { className: "text-xs text-muted-foreground line-clamp-1 mt-1", children: o.description })
            ] })
          ]
        },
        o.id
      )) })
    ] }, l)) })
  ] });
}, qt = ({
  title: t = "Configuration",
  description: n,
  isOpen: i = !0,
  onClose: s,
  children: c,
  className: d,
  actions: g
}) => i ? /* @__PURE__ */ h("div", { className: b("flex flex-col h-full bg-background border-l border-border w-80", d), children: [
  /* @__PURE__ */ h("div", { className: "flex items-center justify-between p-4 border-b border-border", children: [
    /* @__PURE__ */ h("div", { children: [
      /* @__PURE__ */ r(x, { variant: "h4", className: "text-sm font-semibold", children: t }),
      n && /* @__PURE__ */ r(x, { variant: "body", className: "text-xs text-muted-foreground mt-1", children: n })
    ] }),
    s && /* @__PURE__ */ h(A, { variant: "ghost", size: "sm", onClick: s, className: "h-8 w-8 p-0", children: [
      /* @__PURE__ */ r(Gt, { className: "h-4 w-4" }),
      /* @__PURE__ */ r("span", { className: "sr-only", children: "Close" })
    ] })
  ] }),
  /* @__PURE__ */ r("div", { className: "flex-1 overflow-y-auto p-4", children: c }),
  g && /* @__PURE__ */ r("div", { className: "p-4 border-t border-border bg-muted/20", children: g })
] }) : null, Vt = ({
  steps: t,
  currentStepId: n,
  onStepClick: i,
  nodes: s = [],
  onNodeDragStart: c,
  onNodeClick: d,
  selectedNode: g,
  onRulesClose: p,
  rulesPanelContent: l,
  rulesPanelActions: m,
  children: o,
  className: y,
  sidebarWidth: u = 280,
  panelWidth: f = 320
}) => /* @__PURE__ */ h("div", { className: b("flex flex-col h-screen max-h-screen bg-background", y), children: [
  t && t.length > 0 && /* @__PURE__ */ r("div", { className: "border-b border-border p-4 bg-card", children: /* @__PURE__ */ r(
    ot,
    {
      steps: t,
      currentStepId: n || t[0].id,
      onStepClick: i
    }
  ) }),
  /* @__PURE__ */ h("div", { className: "flex flex-1 overflow-hidden", children: [
    /* @__PURE__ */ r(
      "aside",
      {
        className: "border-r border-border bg-card/50",
        style: { width: u },
        children: /* @__PURE__ */ r(
          Wt,
          {
            nodes: s,
            onNodeDragStart: c,
            onNodeClick: d,
            className: "w-full border-none"
          }
        )
      }
    ),
    /* @__PURE__ */ r("main", { className: "flex-1 overflow-auto bg-muted/10 relative", children: o }),
    g && /* @__PURE__ */ r(
      "aside",
      {
        className: "border-l border-border bg-card",
        style: { width: f },
        children: /* @__PURE__ */ r(
          qt,
          {
            title: g.label || "Properties",
            description: g.description,
            onClose: p,
            actions: m,
            className: "w-full border-none",
            children: l
          }
        )
      }
    )
  ] })
] }), v = {
  // ==========================================================================
  // Atoms
  // ==========================================================================
  Button: {
    component: A,
    schema: B,
    category: "atom",
    description: "Primary action button with multiple variants and sizes",
    usageHint: "Use for primary actions, form submissions, or navigation"
  },
  Badge: {
    component: Ke,
    schema: F,
    category: "atom",
    description: "Small status indicator or label",
    usageHint: "Use to show status (active/inactive), counts, or categories"
  },
  Input: {
    component: U,
    schema: L,
    category: "atom",
    description: "Text input field",
    usageHint: "Use within forms for user text input"
  },
  Typography: {
    component: x,
    schema: D,
    category: "atom",
    description: "Text component with semantic variants",
    usageHint: "Use for headings, body text, and captions"
  },
  Spinner: {
    component: Me,
    schema: j,
    category: "atom",
    description: "Loading spinner indicator",
    usageHint: "Use to indicate async operations in progress"
  },
  Skeleton: {
    component: Oe,
    schema: G,
    category: "atom",
    description: "Placeholder loading skeleton",
    usageHint: "Use as content placeholder while data loads"
  },
  Card: {
    component: We,
    schema: z,
    category: "atom",
    description: "Container card with elevation",
    usageHint: "Use to group related content visually"
  },
  Avatar: {
    component: Ie,
    schema: E,
    category: "atom",
    description: "User profile image or initials",
    usageHint: "Use to display user avatars with optional status indicators"
  },
  AvatarGroup: {
    component: Re,
    schema: R,
    category: "atom",
    description: "Group of overlapping avatars",
    usageHint: "Use to show multiple users with overflow indicator"
  },
  // ==========================================================================
  // Molecules
  // ==========================================================================
  Alert: {
    component: qe,
    schema: I,
    category: "molecule",
    description: "Contextual alert message",
    usageHint: "Use for info, success, warning, or error messages"
  },
  Tabs: {
    component: Ve,
    schema: M,
    category: "molecule",
    description: "Tabbed navigation component",
    usageHint: "Use to organize content into switchable panels"
  },
  Breadcrumbs: {
    component: $e,
    schema: K,
    category: "molecule",
    description: "Breadcrumb navigation",
    usageHint: "Use to show hierarchical page location"
  },
  FormField: {
    component: Ye,
    schema: O,
    category: "molecule",
    description: "Form field wrapper with label and error",
    usageHint: "Use to wrap form inputs with labels and validation feedback"
  },
  // ==========================================================================
  // Primitives (Layout)
  // ==========================================================================
  Stack: {
    component: Je,
    schema: W,
    category: "primitive",
    description: "Vertical stack layout",
    usageHint: "Use to arrange children vertically with consistent spacing"
  },
  Inline: {
    component: _e,
    schema: q,
    category: "primitive",
    description: "Horizontal inline layout",
    usageHint: "Use to arrange children horizontally"
  },
  Grid: {
    component: Ze,
    schema: V,
    category: "primitive",
    description: "CSS grid layout",
    usageHint: "Use for multi-column layouts"
  },
  Container: {
    component: Xe,
    schema: $,
    category: "primitive",
    description: "Centered container with max-width",
    usageHint: "Use to constrain content width and center it"
  },
  // ==========================================================================
  // Patterns
  // ==========================================================================
  DataGrid: {
    component: rt,
    schema: J,
    category: "pattern",
    description: "Virtualized data grid for large datasets",
    usageHint: "Use for displaying tabular data with sorting and selection"
  },
  DataTable: {
    component: nt,
    schema: X,
    category: "pattern",
    description: "Data table with built-in features",
    usageHint: "Use for smaller datasets with filtering and actions"
  },
  Pagination: {
    component: at,
    schema: Z,
    category: "pattern",
    description: "Page navigation component",
    usageHint: "Use to navigate between pages of content"
  },
  Dialog: {
    component: Ht,
    schema: _,
    category: "pattern",
    description: "Modal dialog overlay",
    usageHint: "Use for important actions requiring user attention"
  },
  Drawer: {
    component: kt,
    schema: Q,
    category: "pattern",
    description: "Slide-out panel",
    usageHint: "Use for secondary navigation or detail views"
  },
  Dropdown: {
    component: Ct,
    schema: ee,
    category: "pattern",
    description: "Dropdown menu",
    usageHint: "Use for action menus or option selection"
  },
  EmptyState: {
    component: tt,
    schema: te,
    category: "pattern",
    description: "Empty state placeholder",
    usageHint: "Use when no data is available"
  },
  ErrorState: {
    component: Pt,
    schema: ae,
    category: "pattern",
    description: "Error state with retry option",
    usageHint: "Use to display errors with recovery action"
  },
  LoadingState: {
    component: At,
    schema: ne,
    category: "pattern",
    description: "Full loading state placeholder",
    usageHint: "Use while content is loading"
  },
  PageHeader: {
    component: vt,
    schema: re,
    category: "pattern",
    description: "Page header with title and actions",
    usageHint: "Use at the top of pages for title, description, and primary actions"
  },
  Sidebar: {
    component: wt,
    schema: oe,
    category: "pattern",
    description: "Navigation sidebar",
    usageHint: "Use for main app navigation"
  },
  Toolbar: {
    component: et,
    schema: se,
    category: "pattern",
    description: "Horizontal toolbar",
    usageHint: "Use for page-level actions and filters"
  },
  Section: {
    component: Ut,
    schema: ce,
    category: "pattern",
    description: "Content section with optional title",
    usageHint: "Use to group related content with a heading"
  },
  // ==========================================================================
  // Charts
  // ==========================================================================
  ChartLine: {
    component: St,
    schema: le,
    category: "chart",
    description: "Line chart visualization",
    usageHint: "Use for time series or trend data"
  },
  ChartBar: {
    component: xt,
    schema: de,
    category: "chart",
    description: "Bar chart visualization",
    usageHint: "Use for categorical comparisons"
  },
  ChartArea: {
    component: ft,
    schema: pe,
    category: "chart",
    description: "Area chart visualization",
    usageHint: "Use for showing volume over time"
  },
  ChartPie: {
    component: bt,
    schema: me,
    category: "chart",
    description: "Pie chart visualization",
    usageHint: "Use for showing proportions of a whole"
  },
  KpiCard: {
    component: yt,
    schema: ge,
    category: "chart",
    description: "KPI metric card",
    usageHint: "Use to display key metrics with optional sparkline"
  },
  Sparkline: {
    component: ut,
    schema: he,
    category: "chart",
    description: "Compact sparkline chart",
    usageHint: "Use within cards for inline trend visualization"
  },
  // ==========================================================================
  // Layouts
  // ==========================================================================
  AuthenticatedAppShell: {
    component: ht,
    schema: ue,
    category: "layout",
    description: "Full app shell for authenticated users",
    usageHint: "Use as the root layout for authenticated SaaS pages"
  },
  SettingsLayout: {
    component: gt,
    schema: ye,
    category: "layout",
    description: "Settings page layout with nav",
    usageHint: "Use for settings or preference pages"
  },
  SidebarLayout: {
    component: mt,
    schema: be,
    category: "layout",
    description: "Layout with sidebar and content",
    usageHint: "Use for pages with persistent sidebar navigation"
  },
  // ==========================================================================
  // Forms
  // ==========================================================================
  TextField: {
    component: Tt,
    schema: fe,
    category: "form",
    description: "Form text input field",
    usageHint: "Use within SmartForm for text input"
  },
  SelectField: {
    component: Nt,
    schema: xe,
    category: "form",
    description: "Form select dropdown",
    usageHint: "Use within SmartForm for option selection"
  },
  SmartForm: {
    component: Ft,
    schema: Se,
    category: "form",
    description: "Form with built-in validation",
    usageHint: "Use as form container with Zod validation support"
  },
  SchemaForm: {
    component: Bt,
    schema: we,
    category: "form",
    description: "Auto-generated form from JSON schema",
    usageHint: "Use to generate forms from entity schemas automatically"
  },
  // ==========================================================================
  // SaaS Patterns
  // ==========================================================================
  TenantSwitcher: {
    component: pt,
    schema: ve,
    category: "saas",
    description: "Multi-tenant organization switcher",
    usageHint: "Use in header for switching between workspaces/organizations"
  },
  UserMenu: {
    component: dt,
    schema: Ce,
    category: "saas",
    description: "User profile dropdown menu",
    usageHint: "Use in header for user actions (profile, logout)"
  },
  PermissionGuard: {
    component: lt,
    schema: ke,
    category: "saas",
    description: "Permission-based visibility guard",
    usageHint: "Use to conditionally show content based on permissions"
  },
  NetworkBoundary: {
    component: Qe,
    schema: He,
    category: "saas",
    description: "Async state boundary with loading/error handling",
    usageHint: "Use to wrap data-fetching components"
  },
  // ==========================================================================
  // Rich Text
  // ==========================================================================
  RichTextEditor: {
    component: zt,
    schema: Ue,
    category: "pattern",
    description: "WYSIWYG rich text editor",
    usageHint: "Use for content editing with formatting"
  },
  MarkdownRenderer: {
    component: P,
    schema: Ae,
    category: "pattern",
    description: "Markdown content renderer",
    usageHint: "Use to render markdown content safely"
  },
  // ==========================================================================
  // Kanban
  // ==========================================================================
  KanbanBoard: {
    component: ct,
    schema: Pe,
    category: "pattern",
    description: "Kanban board with drag-and-drop",
    usageHint: "Use for task management or workflow visualization"
  },
  // ==========================================================================
  // Workflow
  // ==========================================================================
  WorkflowBuilder: {
    component: Vt,
    schema: Ne,
    category: "pattern",
    description: "Workflow builder interface",
    usageHint: "Use for creating multi-step workflows"
  },
  // ==========================================================================
  // Command Palette
  // ==========================================================================
  CommandPalette: {
    component: st,
    schema: Te,
    category: "pattern",
    description: "Searchable command menu (Cmd+K style)",
    usageHint: "Use for global search and quick actions"
  }
};
function $t(t) {
  return v[t];
}
function Yt(t) {
  return Object.fromEntries(
    Object.entries(v).filter(([n, i]) => i.category === t)
  );
}
function Aa() {
  return Object.keys(v);
}
function Pa(t) {
  const n = Ot.safeParse(t);
  return n.success ? { success: !0 } : { success: !1, error: n.error.message };
}
function Na() {
  const t = ["atom", "molecule", "primitive", "pattern", "layout", "form", "chart", "saas"];
  let n = `# Component Catalog

`;
  for (const i of t) {
    const s = Yt(i);
    if (Object.keys(s).length !== 0) {
      n += `## ${i.charAt(0).toUpperCase() + i.slice(1)}s

`;
      for (const [c, d] of Object.entries(s))
        n += `### ${c}
`, n += `${d.description}
`, d.usageHint && (n += `*Usage:* ${d.usageHint}
`), n += `
`;
    }
  }
  return n;
}
const Be = ze({
  data: {},
  onAction: () => {
  }
}), Jt = () => Ee(Be);
function Fe(t, n) {
  const i = t.match(/^\{\{(.+)\}\}$/);
  if (!i) return t;
  const c = i[1].trim().split(".");
  let d = n;
  for (const g of c) {
    if (d == null) return;
    d = d[g];
  }
  return d;
}
function S(t, n) {
  if (typeof t == "string")
    return Fe(t, n);
  if (Array.isArray(t))
    return t.map((i) => S(i, n));
  if (t && typeof t == "object") {
    const i = {};
    for (const [s, c] of Object.entries(t))
      i[s] = S(c, n);
    return i;
  }
  return t;
}
function w({
  config: t,
  fallback: n
}) {
  const { data: i, onAction: s } = Jt(), c = $t(t.type);
  if (!c)
    return n ? /* @__PURE__ */ r(n, { type: t.type }) : (console.warn(`[UIRenderer] Unknown component type: ${t.type}`), null);
  const d = c.component, p = { ...S(t.props || {}, i) }, l = ["onClick", "onSubmit", "onChange", "onRetry", "onPageChange", "onSelect", "onSwitch", "onCardMove"];
  for (const o of l)
    if (typeof p[o] == "string") {
      const y = p[o];
      p[o] = (u) => s(y, u);
    }
  if (p.action && typeof p.action.onClick == "string") {
    const o = p.action.onClick;
    p.action = {
      ...p.action,
      onClick: (y) => s(o, y)
    };
  }
  let m = null;
  return t.children && (typeof t.children == "string" ? m = Fe(t.children, i) : Array.isArray(t.children) ? m = t.children.map((o, y) => /* @__PURE__ */ r(w, { config: o, fallback: n }, y)) : m = /* @__PURE__ */ r(w, { config: t.children, fallback: n })), p.children && typeof p.children == "string" && (m = p.children, delete p.children), /* @__PURE__ */ r(d, { ...p, children: m });
}
const Ta = ({
  config: t,
  data: n = {},
  onAction: i = () => {
  },
  theme: s,
  fallback: c
}) => {
  const d = k(
    () => ({ data: n, onAction: i, theme: s }),
    [n, i, s]
  );
  return /* @__PURE__ */ r(Be.Provider, { value: d, children: /* @__PURE__ */ r(w, { config: t, fallback: c }) });
}, Ba = {
  /**
   * List page template - DataGrid with header and pagination
   */
  listPage: (t) => ({
    type: "Stack",
    props: { gap: 6 },
    children: [
      {
        type: "PageHeader",
        props: {
          title: t.title,
          description: t.description,
          actions: t.createAction ? [{ label: "Create", onClick: t.createAction, variant: "primary" }] : void 0
        }
      },
      {
        type: "DataGrid",
        props: {
          columns: t.columns,
          data: t.dataBinding
        }
      }
    ]
  }),
  /**
   * Empty state page template - Header with empty state content
   */
  emptyStatePage: (t) => ({
    type: "Stack",
    props: { gap: 6 },
    children: [
      {
        type: "PageHeader",
        props: {
          title: t.title,
          description: t.description
        }
      },
      {
        type: "EmptyState",
        props: {
          title: t.emptyTitle,
          description: t.emptyDescription,
          action: t.action ? {
            label: t.actionLabel || "Create",
            onClick: t.action,
            variant: t.actionVariant || "primary"
          } : void 0
        }
      }
    ]
  }),
  /**
   * Error state page template - Header with error state content
   */
  errorStatePage: (t) => ({
    type: "Stack",
    props: { gap: 6 },
    children: [
      {
        type: "PageHeader",
        props: {
          title: t.title,
          description: t.description
        }
      },
      {
        type: "ErrorState",
        props: {
          title: t.errorTitle,
          description: t.errorDescription,
          onRetry: t.retryAction
        }
      }
    ]
  }),
  /**
   * Loading state page template - Header with loading state content
   */
  loadingStatePage: (t) => ({
    type: "Stack",
    props: { gap: 6 },
    children: [
      {
        type: "PageHeader",
        props: {
          title: t.title,
          description: t.description
        }
      },
      {
        type: "LoadingState",
        props: {
          message: t.message
        }
      }
    ]
  }),
  /**
   * Detail page template - Header with form
   */
  detailPage: (t) => ({
    type: "Stack",
    props: { gap: 6 },
    children: [
      {
        type: "PageHeader",
        props: {
          title: t.title,
          description: t.description
        }
      },
      {
        type: "Card",
        children: {
          type: "SchemaForm",
          props: {
            jsonSchema: t.formSchema,
            onSubmit: t.submitAction
          }
        }
      }
    ]
  }),
  /**
   * Dashboard page template - KPIs with charts
   */
  dashboardPage: (t) => ({
    type: "Stack",
    props: { gap: 6 },
    children: [
      {
        type: "PageHeader",
        props: { title: t.title }
      },
      {
        type: "Grid",
        props: { columns: t.kpis.length },
        children: t.kpis.map((n) => ({
          type: "KpiCard",
          props: {
            title: n.title,
            metric: n.metricBinding
          }
        }))
      },
      ...t.chartBinding ? [
        {
          type: "Card",
          children: {
            type: "ChartLine",
            props: {
              data: t.chartBinding,
              categories: ["value"],
              index: "name",
              h: 300
            }
          }
        }
      ] : []
    ]
  })
};
export {
  be as $,
  Z as A,
  _ as B,
  Q as C,
  ee as D,
  Rt as E,
  te as F,
  ae as G,
  ne as H,
  re as I,
  ie as J,
  oe as K,
  se as L,
  ce as M,
  Ca as N,
  le as O,
  de as P,
  pe as Q,
  zt as R,
  me as S,
  ge as T,
  Ta as U,
  he as V,
  ue as W,
  ka as X,
  Ha as Y,
  Ua as Z,
  ye as _,
  T as a,
  fe as a0,
  xe as a1,
  Se as a2,
  we as a3,
  ve as a4,
  Ce as a5,
  ke as a6,
  He as a7,
  Ue as a8,
  Ae as a9,
  It as aa,
  Mt as ab,
  Pe as ac,
  Ne as ad,
  Kt as ae,
  Te as af,
  Ot as ag,
  v as ah,
  $t as ai,
  Aa as aj,
  Pa as ak,
  Na as al,
  Yt as am,
  a as b,
  N as c,
  B as d,
  F as e,
  G as f,
  z as g,
  Et as h,
  L as i,
  E as j,
  R as k,
  I as l,
  M as m,
  K as n,
  O as o,
  Ba as p,
  W as q,
  q as r,
  j as s,
  D as t,
  Jt as u,
  V as v,
  $ as w,
  Y as x,
  J as y,
  X as z
};
